export const prettifyJointAccountType = (accountType: string) => {
  switch (accountType) {
    case 'JOINT_TENANTS_WITH_RIGHT_OF_SURVIVORSHIP':
      return 'Joint Tenants with Rights of Survivorship'
    case 'TENANTS_IN_COMMON':
      return 'Tenants in Common'
    case 'JOINT_COMMUNITY_PROPERTY':
      return 'Community Property'
    case 'JOINT_TENANTS_BY_THE_ENTIRETY':
      return 'Joint Tenants by the Entirety'
  }
}
